import './App.css';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { Outlet } from "react-router-dom";

function App() {
  return (
    <div className="main-body">
      <Header  />
      <Navbar/>      
      <Outlet />
      <Footer />
    </div>
  );
}

export default App;
